// extracted by mini-css-extract-plugin
export default {"main":"formaddress_main__coHFO","userBox":"formaddress_userBox__lga+2","text":"formaddress_text__5CKx9"};